import { render } from "./AdmUserMng.vue?vue&type=template&id=2db43d92&scoped=true"
import script from "./AdmUserMng.vue?vue&type=script&lang=js"
export * from "./AdmUserMng.vue?vue&type=script&lang=js"

import "./AdmUserMng.vue?vue&type=style&index=0&id=2db43d92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db43d92"]])

export default __exports__